import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import MaskedTextBoxProps from './MaskedTextBoxProps'


export default {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: MaskedTextBoxProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoMaskedTextBox(that.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }

        that.kendoWidget().bind('change', function(){
            var kendoWidget = that.kendoWidget()
            var inputElement = kendoWidget.element
            if(that.v3){
                that.$emit('update:modelValue', inputElement.val())
            } else {
                that.$emit('changemodel', inputElement.val())
            }
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMaskedTextBox()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoMaskedTextBox/KendoMaskedTextBoxMixin.js